import { coercePayTypesObject, payTypesForApiUpdate } from './payTypes';

function isBlankJsonString(s: string): boolean {
  const t = s.trim();
  return !t || t === '{}' || t === '[]' || t === 'null';
}

/** `pay_types` vazio ou `{}` não deve ir ao servidor (apagaria o JSON no banco). */
export function isEmptyPayTypesPayload(payTypes: unknown): boolean {
  if (payTypes == null) return true;
  if (typeof payTypes === 'string') return isBlankJsonString(payTypes);
  if (Array.isArray(payTypes)) {
    if (payTypes.length === 0) return true;
    if (payTypes.length === 1) {
      const item = payTypes[0];
      if (item == null || typeof item !== 'object' || Array.isArray(item)) return true;
      return Object.keys(item as object).length === 0;
    }
    return false;
  }
  if (typeof payTypes === 'object') {
    return Object.keys(payTypes as object).length === 0;
  }
  return true;
}

function isEmptyJsonValue(val: unknown): boolean {
  if (val == null) return true;
  if (typeof val === "string") return isBlankJsonString(val);
  if (Array.isArray(val)) return val.length === 0;
  if (typeof val === "object") return Object.keys(val as object).length === 0;
  return false;
}

/** Remove chaves JSON vazias do payload de update-customer. */
export function stripEmptyJsonFieldsFromCustomerUpdate(
  payload: Record<string, unknown>
): Record<string, unknown> {
  const out = { ...payload };
  const jsonKeys = [
    'pay_types',
    'payment_methods',
    'cardapio_json',
    'catalog',
    'cardapio',
    'bairros_taxas',
    'delivery_fees',
    'colaboradores',
    'employees_allowlist',
    'pedidos_pendentes',
    'pending_orders',
    'licenca_loja',
    'store_license',
    'prazo_atual',
    'current_eta',
    'order_types_public',
    'horario_funcionamento',
    'business_hours',
    'imagem_cardapio',
    'menu_images',
    'gift_claim_settings',
    'appointment_message_templates',
  ] as const;

  for (const key of jsonKeys) {
    if (!(key in out)) continue;
    const val = out[key];
    if (isEmptyJsonValue(val)) {
      delete out[key];
      continue;
    }
    if (key === "pay_types" || key === "payment_methods") {
      if (isEmptyPayTypesPayload(val)) delete out[key];
    }
  }
  return out;
}

export function normalizePayTypesForCustomerUpdate(
  payTypes: unknown
): Record<string, unknown>[] | undefined {
  if (isEmptyPayTypesPayload(payTypes)) return undefined;
  const asObject = coercePayTypesObject(payTypes);
  return payTypesForApiUpdate(asObject);
}
